
export default { name: 'LayoutEmpty' }
